var _g, _path, _rect, _rect2, _rect3, _g2, _path2, _rect4, _rect5, _rect6, _g3, _path3, _rect7, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 78,
    viewBox: "0 0 200 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2938_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.33849C0 6.75974 2.09049 4.66925 4.66924 4.66925L29.6847 4.66925L39.39 4.66925C40.6294 4.66925 41.8179 5.16197 42.6937 6.03885L58.0038 21.3676C58.8782 22.2431 59.3694 23.4299 59.3694 24.6673V44.9063L59.3694 74.9998C59.3694 77.5785 57.2789 79.669 54.7001 79.669H4.66924C2.09049 79.669 0 77.5785 0 74.9998L0 9.33849Z",
    fill: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66895 4.96124L39.3896 4.96124C40.5515 4.96124 41.6662 5.42334 42.4873 6.24542L57.7969 21.5735C58.6166 22.3943 59.0771 23.5073 59.0771 24.6673L59.0771 74.9993C59.0771 77.4169 57.1177 79.3772 54.7002 79.3773H4.66895C2.2515 79.3771 0.291992 77.4168 0.291992 74.9993L0.291992 9.3382C0.292149 6.92085 2.2516 4.9614 4.66895 4.96124Z",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1602 23.7609L40.1602 8.27289C40.1602 7.75274 40.7892 7.49241 41.1568 7.86044L57.2089 23.9321C57.5762 24.2999 57.3157 24.9282 56.7959 24.9282H41.3275C40.6828 24.9282 40.1602 24.4056 40.1602 23.7609Z",
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.11409,
    y: 33.9806,
    width: 31.4292,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.11409,
    y: 39.4503,
    width: 27.3549,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.11409,
    y: 44.9279,
    width: 36.6677,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2938_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3145 10.1968C70.3145 7.61808 72.4049 5.52759 74.9837 5.52759L100.081 5.52759H109.822C111.059 5.52759 112.246 6.01854 113.121 6.89265L128.477 22.2252C129.354 23.1011 129.847 24.2898 129.847 25.5294V45.7647V75.8581C129.847 78.4368 127.757 80.5273 125.178 80.5273H74.9837C72.4049 80.5273 70.3145 78.4368 70.3145 75.8581V10.1968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9834 5.81958L109.822 5.81958C110.982 5.81966 112.094 6.27951 112.915 7.09888L128.271 22.4319C129.093 23.253 129.556 24.3674 129.556 25.5295V75.8577C129.556 78.2752 127.595 80.2356 125.178 80.2356H74.9834C72.566 80.2354 70.6064 78.2751 70.6064 75.8577V10.1965C70.6066 7.77919 72.5661 5.81974 74.9834 5.81958Z",
    stroke: "#4381E5",
    strokeWidth: 0.583655
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.477 24.6124V9.12439C110.477 8.60424 111.106 8.34391 111.473 8.71194L127.525 24.7836C127.893 25.1514 127.632 25.7797 127.112 25.7797H111.644C110.999 25.7797 110.477 25.2571 110.477 24.6124Z",
    fill: "#E1E8FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1348,
    y: 34.5403,
    width: 32.0129,
    height: 2.18977,
    rx: 1.09489,
    fill: "#EAEFFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1328,
    y: 40.01,
    width: 27.9385,
    height: 2.18977,
    rx: 1.09489,
    fill: "#EAEFFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.1328,
    y: 45.4875,
    width: 37.2514,
    height: 2.18977,
    rx: 1.09489,
    fill: "#EAEFFB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2938_1685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.629 9.33849C140.629 6.75974 142.719 4.66925 145.298 4.66925L170.314 4.66925H180.019C181.258 4.66925 182.447 5.16197 183.323 6.03885L198.633 21.3676C199.507 22.2431 199.998 23.4299 199.998 24.6673V44.9063V74.9998C199.998 77.5785 197.908 79.669 195.329 79.669H145.298C142.719 79.669 140.629 77.5785 140.629 74.9998V9.33849Z",
    fill: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.298 4.96124L180.019 4.96124C181.18 4.96124 182.295 5.42334 183.116 6.24542L198.426 21.5735C199.246 22.3943 199.706 23.5073 199.706 24.6673V74.9993C199.706 77.4169 197.747 79.3772 195.329 79.3773H145.298C142.88 79.3771 140.921 77.4168 140.921 74.9993V9.3382C140.921 6.92085 142.881 4.9614 145.298 4.96124Z",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.791 23.7609V8.27289C180.791 7.75274 181.42 7.49241 181.788 7.86044L197.84 23.9321C198.207 24.2999 197.947 24.9282 197.427 24.9282H181.958C181.314 24.9282 180.791 24.4056 180.791 23.7609Z",
    fill: "#8EB6FF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 146.741,
    y: 33.9806,
    width: 31.4292,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146.741,
    y: 39.4503,
    width: 27.3549,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 146.741,
    y: 44.9276,
    width: 36.6677,
    height: 1.60612,
    rx: 0.80306,
    fill: "#155EEF",
    stroke: "#B8D0FF",
    strokeWidth: 0.583655
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2938_1685",
    x: -9.33847,
    y: 0.0000143051,
    width: 78.0461,
    height: 93.6767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.66924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.66924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2938_1685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2938_1685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2938_1685",
    x: 60.976,
    y: 0.858352,
    width: 78.2101,
    height: 93.6767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.66924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.66924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2938_1685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2938_1685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2938_1685",
    x: 131.29,
    y: 0.0000143051,
    width: 78.0461,
    height: 93.6767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.66924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.66924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2938_1685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2938_1685",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSidebar);
export default __webpack_public_path__ + "static/media/banner-sidebar.9ad7fc14a08811ea0c3eb2cfa1f58201.svg";
export { ForwardRef as ReactComponent };